import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paw',
  templateUrl: './paw.component.html',
  styleUrls: ['./paw.component.scss']
})
export class PawComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
